module.exports = __webpack_public_path__ + "static/media/hearts-king.fe881d56.png";